import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BackButton from '../../components/BackButton';

const AddUser = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userData = location.state?.userData;
  const isEditMode = Boolean(userData);

  const initialFormData = {
    BUId:'',
    BUName: '',
    UserName: '',
    Password: '',
    IsAdmin: false,
    IsActive: false,
    S3BucketName: '', 
    S3UploadUrl: '', 
    S3DownloadUrl: '', 
    S3FolderPath: '', 
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
 // const BUId = sessionStorage.getItem("BUId");
    if (isEditMode && userData) {
      console.log('Edit Mode Data:', userData);
      setFormData({
        BUId: userData?.buId,
        BUName: userData?.buName || '',
        UserName: userData?.userName || '',
        Password: userData?.password || '',
        S3BucketName: userData?.s3BucketName || '', 
        S3UploadUrl: userData?.s3UploadUrl || '',  
        S3DownloadUrl: userData?.s3DownloadUrl || '', 
        S3FolderPath: userData?.s3FolderPath || '', 
        IsAdmin: userData?.isAdmin || false,
        IsActive: userData?.isActive || false,

      });
    } else {
    //  if (BUId) {
        setFormData(prev => ({ ...prev}));
    //  }
    }
  }, [isEditMode, userData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData(prev => ({ ...prev, [name]: newValue }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = {
    BUName: 'BU Name',
    UserName: 'User Name',
    Password: 'Password',
    S3BucketName: 'S3 Bucket Name', 
    S3UploadUrl: 'S3 Upload Url', 
    S3DownloadUrl: 'S3 Download Url', 
    S3FolderPath: 'S3 Folder Path',
    };

    Object.entries(requiredFields).forEach(([field, label]) => {
      if (!formData[field]?.trim()) {
        newErrors[field] = `${label} is required`;
      }
    });

    // Password length validation
    // if (formData.Password && formData.Password.length < 6) {
    //   newErrors.Password = 'Password must be at least 6 characters long';
    // }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();

    if (Object.keys(newErrors).length === 0) {
      setLoading(true);

      try {
        const url = isEditMode
          ? `${process.env.REACT_APP_API_URL}/Login/UpdateBusinessUnit/`
          : `${process.env.REACT_APP_API_URL}/Login/SaveBusinessUnit`;

        const response = await fetch(url, {
          method: isEditMode ? 'PUT' : 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        const data = await response.json();

        if (data) {
          alert(` ${data.response} `);
          navigate(-1);
        } else {
          throw new Error(data.message || 'An error occurred');
        }
      } catch (error) {
        console.error('Error:', error);
        alert(error.message || 'An error occurred. Please try again.');
      } finally {
        setLoading(false);
      }
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <BackButton label="Back" />

      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">
            {isEditMode ? 'UPDATE' : 'CREATE'} USER
          </h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6 bg-white p-8 rounded-lg shadow">
          <input type="hidden" name="BUId" value={formData.BUId} />
          {[
           // { name: 'BUId', label: 'BU Id', type: 'hidden' },
            { name: 'BUName', label: 'BU Name', type: 'text' },
            { name: 'UserName', label: 'User Name', type: 'text' },
            { name: 'Password', label: 'Password', type: 'text' },
            { name: 'S3BucketName', label: 'Bucket Name', type: 'text' },
            { name: 'S3UploadUrl', label: 'Upload Url', type: 'text' },
            { name: 'S3DownloadUrl', label: 'Download Url', type: 'text' },
            { name: 'S3FolderPath', label: 'Folder Path', type: 'text' },
          ].map((field) => (
            <div key={field.name}>
              <label htmlFor={field.name} className="block text-sm font-medium text-gray-700">
                {field.label}
              </label>
              <input
                type={field.type}
                name={field.name}
                id={field.name}
                value={formData[field.name] || ''}
                onChange={handleChange}
                readOnly={field.name === 'BUId' && isEditMode}
                className={`mt-1 block w-full rounded-md border ${errors[field.name] ? 'border-red-300' : 'border-gray-300'
                  } px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 ${field.name === 'BUId' && isEditMode ? 'bg-gray-100' : ''}`}
              />
              {errors[field.name] && (
                <p className="mt-1 text-sm text-red-600">{errors[field.name]}</p>
              )}
            </div>
          ))}

          <div className="flex items-center">
            <input
              type="checkbox"
              name="IsAdmin"
              id="IsAdmin"
              checked={formData.IsAdmin}
              onChange={handleChange}
              className="h-4 w-4 text-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="IsAdmin" className="ml-2 text-sm font-medium text-gray-700">
              Is Admin
            </label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              name="IsActive"
              id="IsActive"
              checked={formData.IsActive}
              onChange={handleChange}
              className="h-4 w-4 text-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="IsActive" className="ml-2 text-sm font-medium text-gray-700">
              Is Active
            </label>
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition-colors disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Saving...' : isEditMode ? 'UPDATE' : 'SAVE'}
            </button>
          </div>
        </form>

      </div>
    </div>
  );
};

export default AddUser;
